import {
	magazineByID,
	magazineCreate,
	magazineDestroy,
	magazineUpdate,
	magazinesList,
    // Magazine Sections Imports
    magazineSectionByID, 
	magazineSectionCreate,
	magazineSectionDestroy,
	magazineSectionsList,
	magazineSectionUpdate,
} from '@/services/agency/magazines.service'

export default {
	namespaced: true,
	state: {
		magazinesList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		magazine: {},
		// STATUS Magazine
		magazinesStatus: 'pending',
		magazinesSaveStatus: 'init',
		magazinesDeleteStatus: 'init',

        // Magazine Sections State
		magazineSectionsList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		magazineSection: {},
		// Status for Magazine Sections
		magazineSectionsStatus: 'pending',
		magazineSectionsSaveStatus: 'init',
		magazineSectionsDeleteStatus: 'init',
	},
	getters: {
		getMagazinesList(state) {
			return state.magazinesList
		},
		getMagazine(state) {
			return state.magazine
		},
		// Magazine Status Getters
		getMagazinesDeleteStatus(state) {
			return state.magazinesDeleteStatus
		},
		getMagazinesSaveStatus(state) {
			return state.magazinesSaveStatus
		},
		getMagazinesStatus(state) {
			return state.magazinesStatus
		},

        // Magazine Sections Getters
		getMagazineSectionsList(state) {
			return state.magazineSectionsList
		},
		getMagazineSection(state) {
			return state.magazineSection
		},
		getMagazineSectionsStatus(state) {
			return state.magazineSectionsStatus
		},
		getMagazineSectionsSaveStatus(state) {
			return state.magazineSectionsSaveStatus
		},
		getMagazineSectionsDeleteStatus(state) {
			return state.magazineSectionsDeleteStatus
		},
	},
	mutations: {
		MAGAZINES_LIST(state, value) {
			state.magazinesList = value
		},
		SET_MAGAZINE(state, value) {
			state.magazine = value
		},
		// STATUS Magazine
		MAGAZINES_STATUS(state, value) {
			state.magazinesStatus = value
		},
		MAGAZINE_SAVE_STATUS(state, value) {
			state.magazinesSaveStatus = value
		},
		MAGAZINE_DELETE_STATUS(state, value) {
			state.magazinesDeleteStatus = value
		},

        // Magazine Sections Mutations
		MAGAZINE_SECTIONS_LIST(state, value) {
			state.magazineSectionsList = value
		},
		SET_MAGAZINE_SECTION(state, value) {
			state.magazineSection = value
		},
		MAGAZINE_SECTIONS_STATUS(state, value) {
			state.magazineSectionsStatus = value
		},
		MAGAZINE_SECTION_SAVE_STATUS(state, value) {
			state.magazineSectionsSaveStatus = value
		},
		MAGAZINE_SECTION_DELETE_STATUS(state, value) {
			state.magazineSectionsDeleteStatus = value
		},
	},
	actions: {
		// Magazine Actions
		async fetchMagazineList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('MAGAZINES_STATUS', 'pending')
			commit('MAGAZINES_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await magazinesList(params)
				commit('MAGAZINES_STATUS', 'init')
				commit('MAGAZINES_LIST', data)
				return data
			} catch (error) {
				commit('MAGAZINES_STATUS', 'init')
				throw error
			}
		},
		async fetchMagazineByID({ commit }, params) {
			commit('MAGAZINES_STATUS', 'pending')
			try {
				const { data } = await magazineByID(params)
				commit('MAGAZINES_STATUS', 'init')
				commit('SET_MAGAZINE', data.data)
				return data
			} catch (error) {
				commit('MAGAZINES_STATUS', 'init')
				return error
			}
		},
		async saveNewMagazine({ commit }, params) {
			commit('MAGAZINE_SAVE_STATUS', 'pending')
			try {
				const { data } = await magazineCreate(params)
				commit('MAGAZINE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MAGAZINE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateMagazine({ commit }, params) {
			commit('MAGAZINE_SAVE_STATUS', 'pending')
			try {
				const { data } = await magazineUpdate(params)
				commit('MAGAZINE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MAGAZINE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteMagazineByID({ commit }, params) {
			commit('MAGAZINE_DELETE_STATUS', 'pending')
			try {
				const { data } = await magazineDestroy(params)
				commit('MAGAZINE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MAGAZINE_DELETE_STATUS', 'error')
				return error
			}
		},

        // Magazine Sections Actions
		async fetchMagazineSectionsList({ commit }, params) {
			commit('MAGAZINE_SECTIONS_STATUS', 'pending')
			commit('MAGAZINE_SECTIONS_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await magazineSectionsList(params)
				commit('MAGAZINE_SECTIONS_STATUS', 'init')
				commit('MAGAZINE_SECTIONS_LIST', data)
				return data
			} catch (error) {
				commit('MAGAZINE_SECTIONS_STATUS', 'init')
				throw error
			}
		},
		async fetchMagazineSectionByID({ commit }, params) {
			commit('MAGAZINE_SECTIONS_STATUS', 'pending')
			try {
				const { data } = await magazineSectionByID(params)
				commit('MAGAZINE_SECTIONS_STATUS', 'init')
				commit('SET_MAGAZINE_SECTION', data.data)
				return data
			} catch (error) {
				commit('MAGAZINE_SECTIONS_STATUS', 'init')
				throw error
			}
		},
		async saveNewMagazineSection({ commit }, params) {
			commit('MAGAZINE_SECTION_SAVE_STATUS', 'pending')
			try {
				const { data } = await magazineSectionCreate(params)
				commit('MAGAZINE_SECTION_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MAGAZINE_SECTION_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateMagazineSection({ commit }, params) {
			commit('MAGAZINE_SECTION_SAVE_STATUS', 'pending')
			try {
				const { data } = await magazineSectionUpdate(params)
				commit('MAGAZINE_SECTION_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MAGAZINE_SECTION_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteMagazineSectionByID({ commit }, params) {
			commit('MAGAZINE_SECTION_DELETE_STATUS', 'pending')
			try {
				const { data } = await magazineSectionDestroy(params)
				commit('MAGAZINE_SECTION_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MAGAZINE_SECTION_DELETE_STATUS', 'error')
				throw error
			}
		},
	},
}
